import React from 'react';

import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import './overrides.scss';

import ReactGridLayout from 'react-grid-layout'
import { WidthProvider } from 'react-grid-layout'

const GridLayout = WidthProvider(ReactGridLayout);

export const ReactGrid: React.FunctionComponent<any> = (props) => {
	return (
		<GridLayout {...props}>
			{props.children}
		</GridLayout>
	);
}